import type { AnySchema } from 'joi';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { ResponseSchema } from '../../../../generic/v2/response/response-schema';
import { AutomationRequestName } from '../../../automation-request-name';

export abstract class AutomationResponseSchema extends ResponseSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static readonly error = 'error';

  public static readonly type = 'type';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static readonly Defaults = class {
    public static readonly error = undefined;

    public static readonly type = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: AnySchema } {
    const parameters = {} as any;

    parameters[AutomationResponseSchema.type] = SchemaField.string(AutomationResponseSchema.Defaults.type)
      .required()
      .valid(...Object.values(AutomationRequestName));

    return parameters;
  }
}
